import Submission from 'edge/quoteandbind/common/models/Submission';
import VinExtractionUtil from 'edge/quoteandbind/quickquote/pa/util/VinExtractionUtil';

export default ['$q', 'JsonRPCService', 'qnb.ErrorHandlingService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', 'addressSettings', 'addresslookup.AddressSearchUtil', 'VinLookupService', 'ModalService', function ($q, JsonRPCService, ErrorHandlingService, endpointConfig, xCenterRouteConfig, addressSettings, AddressSearchUtil, VinLookupService, ModalService) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = endpointConfig.slquote;

    return {
        findAddress: function findAddress(addressString) {
            return AddressSearchUtil.lookupAddress(addressString, addressSettings);
        },
        createSubmission: function createSubmission(submissionDTO) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'createBaseOffering', [submissionDTO]).then(function (response) {
                submissionDTO = new Submission(response);
                ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
                return deferred.resolve(submissionDTO);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },


        /**
         * Extracts the text from an image which contains a VIN Number
         * The text is then sent to the VinLookupService which looks up the
         * vehicle and returns to us a promise which when resolved contains a Vehicle object
         * @param {File} vinImage
         * @returns {q.Promise}
         */
        extractTextAndLookupVin: function extractTextAndLookupVin(vinImage) {
            try {
                var vinToLookup = VinExtractionUtil.extractTextFromVinImage(vinImage);
                return VinLookupService.autofillBasedOnVIN(vinToLookup);
            } catch (err) {
                ModalService.showError('quoteandbind.quickquote.common.services.QuickQuoteService.Error', 'quoteandbind.quickquote.common.services.QuickQuoteService.Vehicle ID Number not found. Please try again.');
            }
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/common/services/QuickQuoteService.js
// module id = 1208
// module chunks = 0